<template>
  <div
    class="embed-block"
    :class="config.alignment"
  >
    <div
      ref="embedRef"
      class="embed-block--wrapper"
    />
  </div>
</template>

<script setup>
import * as cheerio from 'cheerio';
import { ref, onMounted } from 'vue';

defineOptions({
  name: 'EmbedBlock',
});

const props = defineProps({
  config: {
    type: Object,
    default: () => ({}),
  },
});

const embedRef = ref(null);

function swapQuotes(str) {
  return str.replace(/"/g, '~~"~~').replace(/'/g, '"').replace(/~~"~~/g, "'");
}

function parseAndMountCode() {
  try {
    const $ = cheerio.load(props.config?.embed ?? '');
    $('a').each((index, element) => {
      const href = $(element).attr('href');
      if (!href) return;

      $(element).attr('href', swapQuotes(href));
    });
    if (embedRef.value) {
      embedRef.value.innerHTML = $.html();

      // no idea why, but scripts only work in accordions when we re-parse them and replace theme entirely
      const scripts = embedRef.value.querySelectorAll('script');
      scripts.forEach((originalScript) => {
        const newScript = document.createElement('script');

        // Copy all attributes from the original script to the new one
        Array.from(originalScript.attributes).forEach((attr) => {
          newScript.setAttribute(attr.name, attr.value);
        });

        // Set the content of the script if it's inline (no `src` attribute)
        if (!newScript.src) {
          newScript.textContent = originalScript.textContent;
        }

        originalScript.parentNode.replaceChild(newScript, originalScript);
      });
    }
  } catch (err) {
    console.error(err);
  }
}

onMounted(() => {
  parseAndMountCode();
});
</script>
<style scoped lang="scss">
iframe {
  display: none;
}
.embed-block {
  display: flex;
  .embed-block--wrapper {
    width: 100%;
  }
  &.left {
    justify-content: flex-start;
  }
  &.center {
    justify-content: center;
  }
  &.right {
    justify-content: flex-end;
  }
}
</style>
